module.exports = __webpack_public_path__ + "media/images/lb/606-4121ccc423efe9ee01c02fecb3b70505.svg";